export const signupLink = "https://ccpathways.lxp.campusinsights.ai/welcome"
